import cn from 'classnames';

export interface AvatarProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  size?: number;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}
export default function Avatar(props: AvatarProps) {
  const { name = 'U', className = '', style = {}, size = 32, onClick } = props;

  return (
    <div
      className={cn(
        'text-[#171717] cursor-default text-base font-medium rounded-full flex items-center justify-center',
        'bg-[linear-gradient(178deg,#B1E3C6_6.58%,#EAFAE0_98.39%)]',
        className
      )}
      style={{
        width: size,
        height: size,
        ...style,
      }}
      onClick={onClick}
    >
      {String(name).slice(0, 1).toUpperCase()}
    </div>
  );
}
